import { render, staticRenderFns } from "./StimulusHeader.vue?vue&type=template&id=63f95a79&scoped=true"
import script from "./StimulusHeader.vue?vue&type=script&lang=js"
export * from "./StimulusHeader.vue?vue&type=script&lang=js"
import style0 from "./StimulusHeader.vue?vue&type=style&index=0&id=63f95a79&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f95a79",
  null
  
)

export default component.exports